export default class Utils {
    static hideClassName() {
        return 'hide';
    }

    static isMobile() {
        if ('ontouchstart' in document.documentElement) {
            return true;
        }

        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./frontend/js/utils.js